module.exports = __webpack_public_path__ + "img/40.00767643.jpg";